import { render, staticRenderFns } from "./UserCascader.vue?vue&type=template&id=10ef811c&scoped=true&"
import script from "./UserCascader.vue?vue&type=script&lang=js&"
export * from "./UserCascader.vue?vue&type=script&lang=js&"
import style0 from "./UserCascader.vue?vue&type=style&index=0&id=10ef811c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef811c",
  null
  
)

export default component.exports